export default {
  namespaced: true,
  state: {
    endpoint: "/inventory/product",
    key: "inventory_product",
    fetchKey: "products",
  },

};
